import { CloseIcon } from '@blueprinthq/joy'
import {
  Box,
  Flex,
  Icon,
  PopoverArrow,
  PopoverContent,
  Text
} from '@chakra-ui/react'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'
import React from 'react'

export const WarningPopover = ({
  type,
  width,
  message,
  onClose
}: {
  type: 'error' | 'warning' | 'info'
  width?: number
  message: string
  onClose: () => void
}) => {
  const renderIcon = () =>
    type === 'error' ? (
      <Icon as={WarningIcon} color="#C6162C" boxSize={6} flexShrink={0} />
    ) : type === 'warning' ? (
      <Icon as={WarningIcon} color="#F8D557" boxSize={6} flexShrink={0} />
    ) : (
      <Icon as={InfoIcon} color="blue.500" boxSize={6} flexShrink={0} />
    )

  const bgColor =
    type === 'error' ? '#FFF2F2' : type === 'warning' ? '#FEF7DD' : 'white'
  const borderColor =
    type === 'error' ? '#C6162C' : type === 'warning' ? '#F8D557' : 'white'

  return (
    <PopoverContent
      bg={bgColor}
      borderWidth={1}
      borderColor={borderColor}
      boxShadow={
        type === 'info'
          ? '0px 4px 6px -2px #0000000D, 0px 10px 15px -3px #0000001A'
          : ''
      }
      p={4}
      width={width ? `${width}px` : '100%'}
      maxWidth="100vw"
      mx="auto"
      sx={{
        '--popper-arrow-shadow-color': borderColor
      }}
    >
      <PopoverArrow bg={bgColor} />
      <Flex justify="space-between" align="flex-start" gap={3}>
        <Flex align="flex-start" gap={3} flex={1} minW={0}>
          {renderIcon()}
          <Text
            color="#282828"
            textAlign="left"
            fontSize="14px"
            lineHeight="1.4"
            wordBreak="break-word"
            flex={1}
            minW={0}
          >
            {message}
          </Text>
        </Flex>
        <Box flexShrink={0} ml={2} onClick={onClose} cursor="pointer">
          <CloseIcon />
        </Box>
      </Flex>
    </PopoverContent>
  )
}

export default WarningPopover
